export default "__VITE_ASSET__009039be__"